import { DatePipe } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { Config } from 'src/app/app-constant';
import { EncryptionService } from 'src/app/service/encryption/encryption.service';
import { HttpService } from 'src/app/service/http/http.service';
import { LoaderService } from 'src/app/service/loader/loader.service';
import { SharedService } from 'src/app/service/shared/shared.service';
import { ConfirmationPopupComponent } from '../confirmation-popup/confirmation-popup.component';
import { MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { DateAdapter } from '@angular/material/core';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { ToastrService } from 'ngx-toastr';

export const MY_DATE_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
}
@Component({
  selector: 'app-extend-due-date-popup',
  templateUrl: './extend-due-date-popup.component.html',
  styleUrls: ['./extend-due-date-popup.component.scss'],
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: 'en-GB' }, // Use en-GB to get DD/MM/YYYY format
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS },
  ],
})
export class ExtendDueDatePopupComponent implements OnInit {
  setExtendedDueDate: any;
  showExtendedDueDate: boolean = false;
  button1: any;
  button2: any;
  color: any;
  skipComment: any='';
  showComment: boolean = false;
  assignedId: any;
  skipDate: any;
  teamDWMTaskId: any;
  minDate:any = null;
  isSubmitBtnClicked:boolean=false;
  extensionNumber:any;
  loggedInUserId:any;
  loggedInUserCompanyID: any;
  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<ExtendDueDatePopupComponent>, public dialog: MatDialog,
    public sharedService: SharedService,
    private loader: LoaderService, private encryptionService: EncryptionService,
    private httpService: HttpService, private config: Config, public router: Router,
    private fb: FormBuilder, private datePipe: DatePipe,
    private activatedroute: ActivatedRoute,public toastr: ToastrService,) { }

  ngOnInit() {
    this.loggedInUserId = Number(sessionStorage.getItem('loggedInUserId'));
    this.loggedInUserCompanyID = Number(this.encryptionService.decryptData(sessionStorage.getItem('loggedInUserCompanyID')));
    this.button1 = this.data?.btn1;
    this.button2 = this.data?.btn2;
    console.log("Button 2222...",   this.button2);
    this.color = this.data?.btn2BgColor;
    this.showExtendedDueDate = this.data?.showExtendedDueDate;
    this.assignedId = this.data?.id;
    this.teamDWMTaskId = this.data?.id;
    this.minDate = this.data?.minDate;
    this.showComment = this.data?.showComment;
    this.skipDate = this.data?.skipDate;
    
    this.extensionNumber = this.data?.extensionNumber
    if(this.data?.minDate!=null){
      this.minDate = new Date(this.data?.minDate)
    }
  }
  btn1Action() {
    this.dialogRef.close(false);
  }

  isBtn2Disabled:boolean=false;

  btn2Action() {
      if (this.isBtn2Disabled) return; // prevent accidental double-clicks
  this.isBtn2Disabled = true;      // disable immediately

    //this.dialogRef.close(true);
    if (this.showExtendedDueDate) {
      this.loader.simpleLoaderWithDuration();
      const request = {
        "dueDate": this.datePipe.transform(this.setExtendedDueDate, 'yyyy-MM-dd'),
        "taskID": this.assignedId
      }
      this.httpService.callPostService(this.config.extendDueDate, request).subscribe((data: any) => {
        this.loader.dismissLoader();
        const successdialogRef = this.dialog.open(ConfirmationPopupComponent, {
          disableClose: true,
          height: '25%',
          width: window.innerWidth <= 500 ? '90%' : window.innerWidth <= 800 ? '50%' : '30%',
          data: {
            msg: data.message,
            btn2: 'OK',
            btn2BgColor: '#F3820E',
            showSuccessIcon: true,
            showSuccessMessage: false,
            showCloseIcon: false
          },
        });
        successdialogRef.afterClosed().subscribe(result => {
          this.dialogRef.close(true);
        });
      })
    } else if (this.showComment) {
      this.isSubmitBtnClicked = true;

      if(this.skipComment==''){
        this.isBtn2Disabled = false;  // re-enable if validation fails
        return
      }
      if(this.errorMsgForComment==true){
        this.toastr.warning('The text cannot exceed 255 characters.', '', {
          timeOut: 3000,
        });
        this.isBtn2Disabled = false;  // re-enable if validation fails
        return;
      }
      this.loader.simpleLoaderWithDuration();
      const request = {
        "companyId": this.loggedInUserCompanyID,
        "employeeId": this.teamDWMTaskId,
        "ids": [],
        "reason": this.skipComment,
        "skipDate": this.datePipe.transform(this.skipDate, 'yyyy-MM-dd'),
        "managerId": this.loggedInUserId
      }
      this.httpService.callPostService(this.config.skipDay, request).subscribe((data: any) => {
        this.loader.dismissLoader();
        this.isSubmitBtnClicked = false;
        const successdialogRef = this.dialog.open(ConfirmationPopupComponent, {
          disableClose: true,
          height: '25%',
          width: window.innerWidth <= 500 ? '90%' : window.innerWidth <= 800 ? '50%' : '30%',
          data: {
            msg: data.message,
            btn2: 'OK',
            btn2BgColor: '#F3820E',
            showSuccessIcon: true,
            showSuccessMessage: false,
            showCloseIcon: false
          },
        });
        successdialogRef.afterClosed().subscribe(result => {
          this.dialogRef.close(true);
        });
        error: () => {
          this.isBtn2Disabled = false; // Re-enable if there's an error
          this.loader.dismissLoader();
        }
      })
    }
  }
  errorMsgForComment:boolean=false;
  checkLengthOfField(string: any) {
    if (string.length > 254) {
      this.errorMsgForComment = true;
      this.toastr.warning('The text cannot exceed 255 characters.', '', {
        timeOut: 3000,
      });
    }else{
      this.errorMsgForComment = false;
    }
  }
}

